import RegisterForFreeMobile from "~/features/registration/components/RegisterForFreeMobile";
import RegisterForFreeDesktop from "~/features/registration/components/RegisterForFreeDesktop";
import useMediaQuery from "~/common/hooks/useMediaQuery";
import { MEDIA_QUERY_MIN_DESKTOP_S } from "~/common/utils/screenSizes";

export interface RegisterForFreePageProps {
  showCustomerRegistration?: boolean;
}

export const RegisterForFreePage = ({ showCustomerRegistration }: RegisterForFreePageProps) => {
  const isDesktop = useMediaQuery(MEDIA_QUERY_MIN_DESKTOP_S);

  return isDesktop ? (
    <RegisterForFreeDesktop showCustomerRegistration={showCustomerRegistration} />
  ) : (
    <RegisterForFreeMobile showCustomerRegistration={showCustomerRegistration} />
  );
};
